module.exports = __webpack_public_path__ + "img/composition-grid-animation.d3527a02.gif";